
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fan-promise",
      function () {
        return require("private-next-pages/fan-promise.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fan-promise"])
      });
    }
  